import { createAction } from '@reduxjs/toolkit';
import { DECREASE_STOCK_PRODUCT, SET_PRODUCT_CARD_INITIAL_STATE } from './actionTypes';
export const decreaseStockProduct = createAction(DECREASE_STOCK_PRODUCT);
export const setProductCardInitialState = createAction(SET_PRODUCT_CARD_INITIAL_STATE);
